import { NotificationType } from "../types/notificationType"
import { makeGetRequest, makePatchRequest } from "./restServices"

async function getAllNotifications() {
    try {
        const notifications = await makeGetRequest(`notifications`)
        if (notifications.data.success)
            return notifications.data.data
    } catch (err) {
        console.log("err", err)
        return { success: false, data: {} }
    }
}

async function markNotificationAsRead(notificationId: string) {
    try {
        const notifications = await makePatchRequest(`notifications/${notificationId}/read`, { read: true })
        if (notifications.data.success)
            return notifications.data.data
    } catch (err) {
        console.log("err", err)
        return { success: false, data: {} }
    }

}

async function filterNotifications(newPatientsEnabled: boolean, deviceErrorsEnabled: boolean, softwareUpdatesEnabled: boolean) {
  try {    
    const notifications = await makeGetRequest(`notifications/filtered?newPatientsEnabled=${newPatientsEnabled}&deviceErrorsEnabled=${deviceErrorsEnabled}&softwareUpdatesEnabled=${softwareUpdatesEnabled}`);
    if (notifications.data?.success) {
      return notifications.data.data;
    }
    return [];
  } catch (err) {
    console.error("Error fetching notifications:", err);
    return [];
  }
}


  
 async function getUserNotifications(userId: string): Promise<NotificationType[]> {
    try {
      const response = await makeGetRequest(`notifications`);
  
      if (response?.data?.success && Array.isArray(response.data.data)) {
        return response.data.data;
      } else {
        throw new Error("Invalid response structure");
      }
    } catch (err) {
      console.error("Error fetching user notifications:", err);
      throw err;
    }
  }
export {
    getAllNotifications,
    markNotificationAsRead,
    filterNotifications,
    getUserNotifications
    
}